import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog({
  open = true,
  setOpen = () => {},
  confirmFunction = () => {},
  cancelFunction = () => {},
  dialogTitle = "",
  dialogContentText = "",
  dialogContent = "",
  dialogActionCancel = "",
  dialogActionConfirm = "",
  fullWidth = false,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    cancelFunction();
    handleClose();
  };

  const handleOk = () => {
    confirmFunction();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={fullWidth}
    >
      <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {dialogContentText}
        </DialogContentText>
        {dialogContent}
      </DialogContent>
      <DialogActions>
        {dialogActionCancel !== "" ? (
          <Button color="inherit" onClick={handleCancel}>
            {dialogActionCancel}
          </Button>
        ) : null}
        <Button onClick={handleOk} color="primary" autoFocus>
          {dialogActionConfirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
